var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssetMailNormalblanco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_695",
    "data-name": "Group 695"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1956",
    "data-name": "Path 1956",
    className: "cls-1",
    d: "M252.26,62.76H47.74A21.85,21.85,0,0,0,25.93,84.57V215.43a21.85,21.85,0,0,0,21.81,21.81H252.26a21.84,21.84,0,0,0,21.81-21.81V84.57A21.83,21.83,0,0,0,252.26,62.76ZM249.2,77.31l-83.78,83.34a21.81,21.81,0,0,1-30.84,0h0L50.8,77.31ZM40.47,212.47V87.54L103.3,150ZM50.8,222.69l62.81-62.4,10.69,10.64a36.36,36.36,0,0,0,51.39,0l10.7-10.66,62.81,62.41Zm208.73-10.22L196.7,150l62.83-62.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetMailNormalblanco);
export default __webpack_public_path__ + "static/media/Asset_Mail-Normalblanco.7b83fffd2b9a6771bcf71a1443ef99e3.svg";
export { ForwardRef as ReactComponent };